module.exports = __webpack_public_path__ + "static/media/bi_security.a11865de.svg";